module.exports = __webpack_public_path__ + "static/media/tipps_nav.e90aa7f2.svg";